import { ItemMessageMediaComponent } from '../../components/item-message-media/item-message-media.component';
import { ItemMessageBusinessCardComponent } from '../../components/item-message-business-card/item-message-business-card.component';
import { ItemMessageQuestionnaireRequestComponent } from '../../components/item-message-questionnaire-request/item-message-questionnaire-request.component';
import { ItemMessageBookingOfferComponent } from '../../components/item-message-booking-offer/item-message-booking-offer.component';
import { ItemMessageComponent } from '../../components/item-message/item-message.component';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import Session from '../../utils/session.service';
import { Input } from '@angular/core';

@Component({
	standalone: true,
	selector: 'item-message-group',
	templateUrl: './item-message-group.component.html',
	imports: [
		CommonModule, ItemMessageMediaComponent, ItemMessageBusinessCardComponent, 
		ItemMessageQuestionnaireRequestComponent, ItemMessageBookingOfferComponent, ItemMessageComponent, FormsModule
	]
})
export class ItemMessageGroupComponent implements OnInit {
	private session: Session = inject(Session);
	
	@Input() lastSeen: any;
	@Input() chat: any;
	@Input() group: any;
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.vm.user = this.session.getSession().user;
	}
	
}
